import domReady from '@wordpress/dom-ready';

const SCROLL_OFFSET_TOP = 150;

// How long to keep correcting scroll position after layout changes (e.g. lazy images).
const LAYOUT_STABLE_MS = 5000;

/**
 * Scrolls the target element into view with SCROLL_OFFSET_TOP from the top of the viewport.
 * Uses scroll-margin-top on the target so scrollIntoView respects the offset.
 * @param {Element|null} target - DOM element to scroll to.
 * @param {'smooth'|'auto'} behavior - 'smooth' for animation, 'auto' for instant (used when correcting).
 */
function scrollToTarget(target, behavior = 'smooth') {
	if (!target) {
		return;
	}

	target.style.scrollMarginTop = `${SCROLL_OFFSET_TOP}px`;
	target.scrollIntoView({
		behavior,
		block: 'start',
	});
}

domReady(() => {
	const selector = '[data-scroll-target]';
	const elements = document.querySelectorAll(selector);

	// Element we're currently keeping in view; used by ResizeObserver to re-scroll on layout change.
	let lastScrollTarget = null;
	// Timeout that stops layout observation after LAYOUT_STABLE_MS.
	let layoutCheckTimeoutId = null;
	// Observes document size changes (e.g. lazy images loading) and re-scrolls to keep target in place.
	let resizeObserver = null;

	// Stops observing layout and clears the pending scroll target.
	function stopObservingLayout() {
		if (layoutCheckTimeoutId) {
			clearTimeout(layoutCheckTimeoutId);
			layoutCheckTimeoutId = null;
		}

		if (resizeObserver && lastScrollTarget) {
			resizeObserver.unobserve(document.documentElement);
			resizeObserver = null;
		}

		lastScrollTarget = null;
	}

	[...elements].forEach((element) => {
		element.addEventListener('click', (event) => {
			event.preventDefault();

			// Use currentTarget so we get the button's attribute even when a child (e.g. icon) is clicked.
			const targetSelector = event.currentTarget.dataset.scrollTarget;

			if (!targetSelector) {
				return;
			}

			const target = document.querySelector(targetSelector);

			if (!target) {
				return;
			}

			stopObservingLayout();
			lastScrollTarget = target;

			scrollToTarget(target, 'smooth');

			// When the document resizes (e.g. images load), re-scroll so the target stays at the correct position.
			resizeObserver = new ResizeObserver(() => {
				if (lastScrollTarget) {
					scrollToTarget(lastScrollTarget, 'auto');
				}
			});

			resizeObserver.observe(document.documentElement);

			layoutCheckTimeoutId = setTimeout(stopObservingLayout, LAYOUT_STABLE_MS);
		});
	});
});
